import { doPost } from "../../Common/utils/https";
import { getRequestHeaders } from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";
import { WLAbTestPayload } from "../../Common/models/config";
import { AxiosResponse } from "axios";
const baseUrl = cloudFunctionsUrl;

export const recordABTest = async (
  data: WLAbTestPayload
): Promise<AxiosResponse<void>> => {
  const url = `${baseUrl}abTest/recordABTest`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, data);
};

export const markABTestAsConverted = async (
  data: WLAbTestPayload
): Promise<AxiosResponse<void>> => {
  const url = `${baseUrl}abTest/markABTestAsConverted`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, data);
};
